import script from "./HolesView.vue?vue&type=script&setup=true&lang=js"
export * from "./HolesView.vue?vue&type=script&setup=true&lang=js"

import "./HolesView.vue?vue&type=style&index=0&id=5b3dc8ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3dc8ba"]])

export default __exports__